$("document").ready(function () {
  const calendar = $("#calendar-business-hours");
  if (calendar.length) {
     // Function to calculate holidays dynamically
    function calculateHolidays(year) {
      let date;
      constHolidays.forEach((holiday) => {
        date = new Date(holiday + " " + year);
        holidays.push(date.toDateString());
        if (date.getDay() === 0) { // If Sunday, observe on Monday
          date.setDate(date.getDate() + 1);
        } else if (date.getDay() === 6) { // If Saturday, observe on Friday
          date.setDate(date.getDate() - 1);
        }
        holidays.push(date.toDateString());
      });

      // Memorial Day - Last Monday in May
      date = new Date(`June 1 ${year}`);
      do {
        date.setDate(date.getDate() - 1);
      } while (date.getDay() !== 1);
      holidays.push(date.toDateString());

      // Labor Day - First Monday in September
      date = new Date(`September 1 ${year}`);
      while (date.getDay() !== 1) {
        date.setDate(date.getDate() + 1);
      }
      holidays.push(date.toDateString());

      // Thanksgiving - Fourth Thursday in November
      date = new Date(`November 22 ${year}`);
      while (date.getDay() !== 4) {
        date.setDate(date.getDate() + 1);
      }
      holidays.push(date.toDateString());

      // Day after Thanksgiving
      date.setDate(date.getDate() + 1);
      holidays.push(date.toDateString());

      // Day before Thanksgiving
      date.setDate(date.getDate() - 2);
      additionalDays.push([date.toDateString(), "8:30 AM - 1:00 PM CT"]);

      // Christmas Eve 
      date = new Date(`December 24 ${year}`);
      if ((date.getDay() >= 1) && (date.getDay() <= 5)) { // Monday - Friday
        additionalDays.push([date.toDateString(), "8:30 AM - 2:00 PM CT"]);
      }
    }

    // Function to generate the calendar for a specific month and year
    function generateCalendar(year, month) {
      let calendarHTML = `<div class="calendar-grid">`;

      const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      calendarHTML += `<div class="calendar-header calendar-header-month">${monthNames[month]} ${year}</div>`;
      daysOfWeek.forEach((day) => {
        calendarHTML += `<div class="calendar-header">${day}</div>`;
      });

      const current_month = today.getMonth();
      const current_date = today.getDate();
      const date = new Date(year, month, 1);
      const firstDay = date.getDay();
      for (let i = 0; i < firstDay; i++) {
        calendarHTML += `<div class="calendar-cell empty"> </div>`;
      }

      while (date.getMonth() === month) {
        const dayOfWeek = date.getDay();
        let date_class = "";
        let dayText = businessHours[dayOfWeek];

        // Commented below for the calendar update to exclude Friday, July 03, 2026 from holiday | Updated by Sandro | Date: July 02, 2026
        /* let cellClass = holidays.includes(date.toDateString()) ? "closed" : "";
        if (holidays.includes(date.toDateString())) {
          dayText = `Closed`;
        } */
       // End of commenting the original script above

       // Start of additional script for the update to exlcude Friday, July 03, 2026 as holiday | Upated by Sandro | Date: July 02, 2026
        let cellClass = "";

        if (excludedClosures.includes(date.toDateString())) {
          // Force normal hours for this date, skip holiday/additionalDays checks entirely
          dayText = businessHours[dayOfWeek];
        } else {
          cellClass = holidays.includes(date.toDateString()) ? "closed" : "";
          if (holidays.includes(date.toDateString())) {
            dayText = `Closed`;
        }
        // End of additional script for the update to exlcude Friday, July 03, 2026 as holiday | Upated by Sandro | Date: July 02, 2026

          // Check for additional specified closed days
          additionalDays.forEach((day) => {
            if (new Date(day[0]).toDateString() === date.toDateString()) {
              dayText = day[1];
              cellClass = "closed";
            }
          });
        }

        // Color code previous and current date
        if (date.getMonth() === current_month) {
          if (date.getDate() == current_date) {
            date_class = 'current-date';
          } else if (date.getDate() < current_date) {
            date_class = 'previous-date';
          }
        }

        calendarHTML += `<div class="calendar-cell ${cellClass} ${date_class}"><div class="calendar-date-text">${date.getDate()}</div>${dayText}</div>`;
        date.setDate(date.getDate() + 1);
      }

      calendarHTML += `</div></div><br>`;
      return calendarHTML;
    }

    // Start of additional array for the update to exlcude Friday, July 03, 2026 as holiday | Upated by Sandro | Date: July 02, 2026
    const excludedClosures = ["Fri Jul 03 2026"]; // force these dates separated by comma to show normal hours
    // End of additional array for the update to exlcude Friday, July 03, 2026 as holiday | Upated by Sandro | Date: July 02, 2026

    const constHolidays = ["January 1", "July 4", "December 25"];
    const weekNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const businessHours = [
      "Closed", // Sunday default
      "8:30 AM - 5:00 PM CT", // Monday default
      "8:30 AM - 5:00 PM CT", // Tuesday default
      "8:30 AM - 5:00 PM CT", // Wednesday default
      "8:30 AM - 5:00 PM CT", // Thursday default
      "8:30 AM - 5:00 PM CT", // Friday default
      "9:00 AM - 4:00 PM CT", // Saturday default
    ];
    const additionalDays = [
      ["Fri Dec 17 2021", "8:30 AM - 2:00 PM CT"],
      ["Sat Dec 18 2021", "Closed"],

      ['Fri Dec 16 2022', '8:30 AM - 2:00 PM CT'],
      ['Sat Dec 17 2022', 'Closed'],
      ['Fri Dec 23 2022', '8:30 AM - 3:00 PM CT'],
      ['Sat Dec 24 2022', 'Closed'],
      ['Sat Dec 31 2022', 'Closed'],

      ['Tue Jan 31 2023', 'Closed due to icy weather'],
      ['Wed Feb 01 2023', 'Closed due to icy weather'],
      ['Thu Feb 02 2023', 'Closed due to power outage'],
      ['Fri Dec 15 2023', '8:30 AM - 2:00 PM CT'],
      ['Sat Dec 16 2023', 'Closed'],
      ['Sat Dec 23 2023', 'Closed'],
      ['Tue Dec 26 2023', '12:00 PM - 5:00 PM CT'],
      ['Sat Dec 30 2023', 'Closed'],

      ['Fri Dec 13 2024', '8:30 AM - 2:00 PM CT'], // Close for Christmas party
      ['Sat Dec 14 2024', 'Closed'],
      ['Sat Dec 21 2024', 'Closed'],
      ['Tue Dec 24 2024', '8:30 AM - 2:00 PM CT'],
      ['Thu Dec 26 2024', '12:00 PM - 5:00 PM CT'],
      ['Sat Dec 28 2024', 'Closed'],
      ['Tue Dec 31 2024', '8:30 AM - 2:00 PM CT'],
      
      ['Tue Jan 21 2025', 'Closed due to weather'],
      ['Fri Dec 12 2025', '8:30 AM - 3:00 PM CT'], // Christmas party
      ['Sat Dec 13 2025', 'Closed'],
      ['Sat Dec 20 2025', 'Closed'],
      ['Fri Dec 26 2025', '12:00 PM - 5:00 PM CT'],
      ['Sat Dec 27 2025', 'Closed'],

      ['Fri Dec 11 2026', '8:30 AM - 3:00 PM CT'], // Christmas party
      ['Sat Dec 12 2026', 'Closed'], // Last 3 Saturdays of the year
      ['Sat Dec 19 2026', 'Closed'], // Last 3 Saturdays of the year
      ['Sat Dec 26 2026', 'Closed'], // Last 3 Saturdays of the year

    ];
    const today = new Date();
    const holidays = [];
    
    calculateHolidays(today.getFullYear());
    calculateHolidays(today.getFullYear() + 1);

    // Generate and display the current month and the next month
    let cal = generateCalendar(today.getFullYear(), today.getMonth());
    let temp_month = today.getMonth() + 1;
    cal += generateCalendar(today.getFullYear() + Math.trunc(temp_month / 12), temp_month % 12);
    // temp_month = temp_month + 1;
    // cal += generateCalendar(today.getFullYear() + Math.trunc(temp_month / 12), temp_month % 12);

    calendar.html(cal);
  }
});